// The privacy policy says error reports carry no email address, username or
// content. Climbers' handles appear in /crew URLs (pages and API calls), which
// Sentry records in the request URL, breadcrumbs and transaction names, so
// they're replaced before anything is sent. Replays already mask all text.
const EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
const CREW_REQUEST_HANDLE = /\/crew\/requests\/(?!(?:incoming|sent)(?:[/?#"'\s]|$))[^/?#"'\s]+/g;
const CREW_HANDLE = /\/crew\/(?!(?:feed|followers|following|search|requests|:handle)(?:[/?#"'\s]|$))[^/?#"'\s]+/g;
// Search terms, plus one-time verification and reset tokens in page URLs.
const SENSITIVE_PARAM = /([?&](?:q|token)=)[^&#"'\s]*/g;

function scrubString(value: string): string {
  return value
    .replace(EMAIL, "[email]")
    .replace(CREW_REQUEST_HANDLE, "/crew/requests/:handle")
    .replace(CREW_HANDLE, "/crew/:handle")
    .replace(SENSITIVE_PARAM, "$1[redacted]");
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (!value || typeof value !== "object") return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

/**
 * Recursively scrub handles, search terms, tokens and emails from Sentry
 * event data. Only plain data is rebuilt: class instances (such as the SDK's
 * own Scope objects in sdkProcessingMetadata) are passed through untouched.
 */
export function scrubForSentry<T>(value: T): T {
  if (typeof value === "string") return scrubString(value) as T;
  if (Array.isArray(value)) return value.map((item) => scrubForSentry(item)) as T;
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, key === "sdkProcessingMetadata" ? item : scrubForSentry(item)])
    ) as T;
  }
  return value;
}
